import { useAppDispatch } from "@/shared/lib/redux"
import { 
    openCreateInvitationModal as openCreateInvitationModalAction,
    openDeleteInvitationModal as openDeleteInvitationModalAction,
    openInspectInvitationModal as openInspectInvitationModalAction
} from '../../../model'
import { IInvitation } from "@/shared/api/invitations"
import { RoleType } from "@/shared/api/users"
export const useUpdateInvitationModal = () => {
    const dispatch = useAppDispatch()

    const openCreateInvitationModal = (role: RoleType, onCreate?: () => void) => {
        dispatch(openCreateInvitationModalAction({
            role,
            onCreate
        }))
    }
    const openInspectInvitationModal = (invitation: IInvitation) => {
        dispatch(openInspectInvitationModalAction({
            data: invitation
        }))
    }
    const openDeleteInvitationModal = (invitation: IInvitation, onDelete?: () => void) => {
        dispatch(openDeleteInvitationModalAction({
            data: invitation,
            onDelete
        }))
    }
    return {
        openCreateInvitationModal,
        openDeleteInvitationModal,
        openInspectInvitationModal
    }
}